import React from "react";
import { renderStatusImage } from "./imageRenderer";

export const DateFrom = ( fromDate,toDate) => {
  return (
    <div className="w-[8%] ">
      <div
        className={
          toDate.slice(0, 2) - fromDate.slice(0, 2) <= 2
            ? "h-[100%] content-center  font-rubik  font-light text-xl bg-[#ff0d0d3b] rounded-l-[8px] "
            : "h-[100%] content-center  font-rubik  font-light text-xl rounded-l-[8px]"
        }
      >
        {fromDate}
      </div>
    </div>
  );
};

export const DateStorage = ( date) => {
  return (
    <div className="w-[8%] content-center font-rubik  font-light">
      <div
        className="h-[90%] content-center font-light text-xl border-[#dbdbdb] border-[2px] rounded-l-[8px] mx-1"
      >
        {date}
      </div>
    </div>
  );
};

export const DateTo = (toDate) => {
  return (
    <div className="w-[8%] h-[100%] content-center font-rubik text-xl font-light">
      {toDate}
    </div>
  );
};

export const Button = (image, onClick) => {
  return (
    <div className="w-[12%] content-center">
    <button
      className="flex justify-center items-center w-[99%] h-[90%] bg-[#e6e6e6] rounded-r-[8px] font-medium text-[1vw] text-white hover:bg-[#739D00]"
      onClick={onClick}
    >
      {image}
    </button>
    </div>
  );
};

export const ButtonPrint = (image, onClick) => {
  return (
    <div className="w-[20%] content-center">
    <button
      className=" h-[90%] w-[99%] bg-[#FF3D00] rounded-r-[8px] hover:bg-[#ACCF49] mr-1"
      onClick={onClick}
    >
      {image}
    </button>
  </div>
  );
};

export const StatusDotWithCount = ({ count, status, onClick }) => {
  return (
    <div 
      className="relative w-[50px] h-[50px] flex items-center justify-center transition-all duration-200 ease-in-out" 
      onClick={onClick}
    >
      <div className="absolute top-0 right-0 w-[20px] h-[20px] rounded-[50%] bg-[#ffffffc4] flex items-center justify-center text-black z-10">
        {count}
      </div>
      <div className="w-[40px] h-[40px] flex items-center justify-center">
        {renderStatusImage(status)}
      </div>
    </div>
  );
};

export const EmptyStatusDot = ({ onClick }) => {
  return (
    <div
      className="w-[50px] h-[50px] flex items-center justify-center rounded-[50%] hover:bg-[#739D00] transition-all duration-200 ease-in-out"
      onClick={onClick}
    >
      <div className="w-[10px] h-[10px] rounded-[50%] bg-[#B1F100]"></div>
    </div>
  );
};